// src/lib/masks.ts
export function onlyDigits(v: string) {
  return (v || "").replace(/\D+/g, "");
}

export function maskCPF(v: string) {
  const d = onlyDigits(v).slice(0, 11);
  const p1 = d.slice(0, 3);
  const p2 = d.slice(3, 6);
  const p3 = d.slice(6, 9);
  const p4 = d.slice(9, 11);
  let out = p1;
  if (p2) out += "." + p2;
  if (p3) out += "." + p3;
  if (p4) out += "-" + p4;
  return out;
}

export function maskCNPJ(v: string) {
  const d = onlyDigits(v).slice(0, 14);
  const p1 = d.slice(0, 2);
  const p2 = d.slice(2, 5);
  const p3 = d.slice(5, 8);
  const p4 = d.slice(8, 12);
  const p5 = d.slice(12, 14);
  let out = p1;
  if (p2) out += "." + p2;
  if (p3) out += "." + p3;
  if (p4) out += "/" + p4;
  if (p5) out += "-" + p5;
  return out;
}

export function maskCEP(v: string) {
  const d = onlyDigits(v).slice(0, 8);
  const p1 = d.slice(0, 5);
  const p2 = d.slice(5, 8);
  return p2 ? `${p1}-${p2}` : p1;
}

export function maskBRPhone(v: string) {
  // (##) #####-#### ou (##) ####-####
  const d = onlyDigits(v).slice(0, 13); // suporta +55 opcional no começo, mas aqui só máscara local
  // Se user colar +55..., remove 55
  const dd = d.startsWith("55") ? d.slice(2) : d;

  const ddd = dd.slice(0, 2);
  const rest = dd.slice(2);

  if (!ddd) return "";
  if (rest.length <= 4) return `(${ddd}) ${rest}`;
  if (rest.length <= 8) return `(${ddd}) ${rest.slice(0, 4)}-${rest.slice(4)}`;
  return `(${ddd}) ${rest.slice(0, 5)}-${rest.slice(5, 9)}`;
}

export function normalizeCepToApi(v: string) {
  return onlyDigits(v).slice(0, 8) || null;
}

export function normalizeDocToApi(v: string) {
  const d = onlyDigits(v);
  return d ? d : null;
}
